import { Component, ElementRef, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  Validators,
  UntypedFormGroup,
  UntypedFormArray,
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ViewChild } from "@angular/core";
import { Clients } from "../../../../models/clients";
import { Category } from "../../../../models/category";
import { UntypedFormControl } from "@angular/forms";
import { CategoryService } from "../../../../services/categories.service";
import { ConfirmationService, MessageService, SelectItem } from "primeng/api";
import moment from "moment";
import {
  FISCAL_CODE_VALIDATOR_REGEX,
  SEX_LIST,
  STATE_LIST,
  BUSINESS_STATE_LIST,
  STATE_PUBLISHED,
  FEATURED_OPTIONS,
} from "../../../constants/constants";
import { ComuniService } from "src/app/services/comuni.service";
import { Comuni } from "src/app/models/comuni";
import { CommonModule } from "@angular/common";
import { Billings } from "src/app/models/billings";
import { Personal_data } from "src/app/models/personal_data";
import { NgxSpinnerService } from "ngx-spinner";
import { NewsService } from "src/app/services/news.service";
import { PagesService } from "src/app/services/pages.service";
import { Pages } from "src/app/models/pages";
import { FeaturesTechnicalDataService } from "src/app/services/features_technical_data";
import { TrustpilotService } from "src/app/services/truspilot.service";
import { Trustpilot } from "src/app/models/trustpilot";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ToastModule } from "primeng/toast";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { SelectModule } from "primeng/select";
import { RatingModule } from "primeng/rating";
import { TextareaModule } from "primeng/textarea";
import { TooltipModule } from "primeng/tooltip";

import { SelectButtonModule } from "primeng/selectbutton";

@Component({
  standalone: true,
  selector: "app-trustpilot-form",
  templateUrl: "./trustpilot-form.component.html",
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    InputTextModule,
    ButtonModule,
    CardModule,
    ToastModule,
    ConfirmDialogModule,
    SelectModule,
    RatingModule,
    TextareaModule,
    TooltipModule,
    SelectButtonModule,
  ],
})
export class TrustpilotFormComponent implements OnInit {
  @ViewChild("myInput", { static: false }) myInputVariable: ElementRef;

  pageTitle: string;
  error: string;
  uploadError: string;

  blogForm: UntypedFormGroup;
  selectedDate: Date;
  date: Date;
  deleteButton: boolean;
  statePublished: any[];
  currentUser: any;
  stateOptions: any[];
  selectedStatePublished: SelectItem[] = [];
  element: Trustpilot;
  id: number;

  trackByFn(index, item) {
    return item.id;
  }

  constructor(
    private fb: UntypedFormBuilder,
    private messageService: MessageService,
    private spinner: NgxSpinnerService,
    private trustpilotService: TrustpilotService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    if (this.date) {
      this.selectedDate = new Date(this.date);
    }
    this.currentUser = JSON.parse(localStorage.getItem("currentUser") || "[]");
    this.stateOptions = STATE_LIST;
    this.statePublished = FEATURED_OPTIONS;
    const userId = this.currentUser.user_id;
  }

  ngOnInit() {
    this.spinner.show();

    const id = this.route.snapshot.paramMap.get("id");

    if (id) {
      this.pageTitle = "Modifica Trustpilot Review";
      this.deleteButton = true;

      this.trustpilotService.getId(+id).subscribe((res) => {
        this.element = res;

        this.blogForm.patchValue({
          name: res.name,
          description: res.description,
          seo_url: res.seo_url,
          seo_title: res.seo_title,
          featured: res.featured,
          seo_description: res.seo_description,
          is_active: res.is_active,
          id: res.id,
        });

        this.id = res.id;
      });
    } else {
      this.deleteButton = false;
      this.pageTitle = "Aggiungi Trustpilot Review";
    }

    this.blogForm = this.fb.group({
      id: [""],
      name: ["", Validators.required],
      description: [""],
      seo_url: [""],
      seo_title: [""],
      seo_description: [""],
      is_active: ["0"],
      featured: ["0"],
    });

    setTimeout(() => {
      this.spinner.hide();
    }, 200);
  }

  onSubmit() {
    const formData = new FormData();
    formData.append("name", this.blogForm.get("name").value);
    formData.append("description", this.blogForm.get("description").value);
    formData.append("is_active", this.blogForm.get("is_active").value);
    formData.append("featured", this.blogForm.get("featured").value);
    formData.append("seo_url", this.blogForm.get("seo_url").value);
    formData.append("seo_title", this.blogForm.get("seo_title").value);
    formData.append("seo_description", this.blogForm.get("description").value);

    const id = this.blogForm.get("id").value;

    if (id) {
      this.trustpilotService.update(formData, +id).subscribe(
        (res) => {
          if (res.status == "error") {
            this.uploadError = res.message;
            this.messageService.add({
              key: "myKey1",
              severity: "warn",
              summary: "Attenzione",
              detail: "Salvato senza sucesso",
            });
          } else {
            this.messageService.add({
              key: "myKey1",
              severity: "success",
              summary: "Attenzione",
              detail: "Salvato con sucesso",
            });
          }
        },
        (error) => (this.error = error),
      );
    } else {
      this.trustpilotService.create(formData).subscribe(
        (res) => {
          if (res.status === "error") {
            this.uploadError = res.message;
          } else {
            this.messageService.add({
              key: "myKey1",
              severity: "success",
              summary: "Attenzione",
              detail: "Salvato con sucesso",
            });
            this.router.navigate(["/admin/pages"]);
          }
        },
        (error) => (this.error = error),
      );
    }
  }
}
